import React from "react";

const About = () => {
  return (
    <div className="about-div">
      <div
        className="hero d-flex align-items-center justify-content-center"
        style={{ height: "250px" }}
      >
        <h2 className="about-h2">About Akwaaba</h2>
      </div>
      <div>
        <p>Akwaaba is a Hackney-based social centre for migrants. We offer a space for rest, play, learning and mutual support. Akwaaba is for all migrants regardless of immigration status, ‘race’, religion, country of origin, age, sexual orientation, gender identity and (dis)ability. </p> <br />

        <p> We believe that no-one is illegal. We are committed to actively opposing racism and all other forms of discrimination and oppression.</p> <br />

        <p> Our aim is to build community and foster care, cooperation and solidarity. As a community, we try to make decisions collectively and give all members an equal say in how the social centre is run. Akwaaba is a volunteer-run space.</p>
      </div>
     
    </div>
  );
};

export default About;
